// extracted by mini-css-extract-plugin
export default {"root":"NutritionalListPage_root__Rh9mr"};